import { getStorage } from 'firebase/storage';

const storage = getStorage();

export default storage;
